export default __webpack_public_path__ + "static/media/logo.eafa3a7d.svg";